import React from "react";
import type { FormattedInvestmentPrice } from "../lib/canvasArtworkHelpers";

type CanvasInvestmentPriceProps = {
  price: FormattedInvestmentPrice;
  layout?: "inline" | "stacked";
  size?: "sm" | "md" | "lg";
  className?: string;
};

const primarySizeClass: Record<NonNullable<CanvasInvestmentPriceProps["size"]>, string> = {
  sm: "text-xs font-medium text-canvas-700",
  md: "text-sm font-medium text-canvas-800",
  lg: "font-display text-xl font-semibold text-canvas-950 sm:text-2xl",
};

const secondarySizeClass: Record<NonNullable<CanvasInvestmentPriceProps["size"]>, string> = {
  sm: "text-[11px] text-canvas-500",
  md: "text-xs text-canvas-500",
  lg: "text-sm text-canvas-500",
};

export function CanvasInvestmentPrice({
  price,
  layout = "inline",
  size = "md",
  className = "",
}: CanvasInvestmentPriceProps) {
  if (layout === "stacked") {
    return (
      <span className={className}>
        <span className={`block ${primarySizeClass[size]}`}>{price.primary}</span>
        {price.secondary && (
          <span className={`mt-0.5 block ${secondarySizeClass[size]}`}>
            {price.secondary}
          </span>
        )}
      </span>
    );
  }

  return (
    <span className={className}>
      <span className={primarySizeClass[size]}>{price.primary}</span>
      {price.secondary && (
        <span className={`ms-2 ${secondarySizeClass[size]}`}>{price.secondary}</span>
      )}
    </span>
  );
}
